var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view-abnormal',{attrs:{"imageUrl":_vm.imageUrl,"status":"404","tips":"抱歉，您访问的页面不存在"}})
}
var staticRenderFns = []

export { render, staticRenderFns }